import { render, staticRenderFns } from "./UploadPop.vue?vue&type=template&id=82bc57ca&"
import script from "./UploadPop.vue?vue&type=script&lang=js&"
export * from "./UploadPop.vue?vue&type=script&lang=js&"
import style0 from "./UploadPop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports